import { useState } from "react";
import { APP_VERSION, BUILD_NAME, FOOTER_NOTES, KNOWN_ISSUES, PLATFORM, RELEASE_NOTES } from "../lib/version";

/**
 * Small footer: version + an (i) toggle that shows map credits and the release note.
 * `overlay` = floats over the bottom-left of a map (replaces MapLibre's attribution button);
 * otherwise it sits at the bottom of a normal page.
 * `mapCredits` lists the active map providers (OpenStreetMap is always included).
 */
export default function AppFooter({ overlay = false, mapCredits = [] }: { overlay?: boolean; mapCredits?: string[] }) {
  const [open, setOpen] = useState(false);
  const credits = ["© OpenStreetMap contributors", "OpenFreeMap / OpenMapTiles", ...mapCredits];
  return (
    <footer className={`appfoot ${overlay ? "overlay" : ""} ${open ? "open" : ""}`}>
      {open && (
        <div className="appfoot-panel" role="dialog" aria-label="Credits and version">
          <div><b>Map data</b> {credits.join(" · ")}</div>
          <div><b>{BUILD_NAME}</b> | What’s new: {latestNotes()}</div>
          {KNOWN_ISSUES.length > 0 && <div className="appfoot-known"><b>Known issue{KNOWN_ISSUES.length > 1 ? "s" : ""}:</b> {KNOWN_ISSUES.join(" · ")}</div>}
          <div className="sub">{PLATFORM} {APP_VERSION} · telematics tracking system designed and built by Skyward Industries · © {new Date().getFullYear()} Skyward Industries Pte Ltd, Fiji</div>
        </div>
      )}
      <button className="appfoot-btn" onClick={() => setOpen(!open)} aria-expanded={open} title="Credits and version">
        <span className="mono">{PLATFORM} {APP_VERSION}</span>
        <span className="appfoot-i" aria-hidden="true">{open ? "×" : "i"}</span>
      </button>
    </footer>
  );
}

/** The newest customer-facing notes (V3.10.0: releases with nothing for customers have no note), as one short list. */
function latestNotes() {
  return RELEASE_NOTES.slice(0, FOOTER_NOTES).map(([, n]) => n.replace(/\.$/, "")).join(" · ") + ".";
}
